import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Checkbox } from "semantic-ui-react";
import { SettingsContext } from "../context";

import axios from "axios";
import api from "../context/api";
import Dimension from "./Dimension";

function ModelVCheckbox() {
  const {
    exportObj,
    setExportObj,
    setGlbOriginalFile,
    editorProductInfo,
    productMatches,
    setProductMatches,
    usePoster,
    useThumbnail,
    setUseThumbnail,
    setUsePoster,
    setCameraOrbit,
    authenticationToken,
    disabled,
    setDisabled,
  } = useContext( SettingsContext );

  const [cameraVertical, setCameraVertical] = useState( "0" );
  const [cameraZoom, setCameraZoom] = useState( "auto" );
  const [cameraHorizontal, setCameraHorizontal] = useState( "75" );
  const [matchCode, setMatchCode] = useState( "" );

  const [sugarModelViewer, setSugarModelViewer] = useState( {} );

  const [a, setA] = useState( true );

  useEffect( () => {
    //match
    if ( !editorProductInfo.id ) exportObj[2].isSelected = true;

    let modelViewer = document.getElementById( "modelViewer" );
    if ( modelViewer.cameraOrbit ) {
      let cameraOrbitPattern = /([0-9]*)deg ([0-9]*)deg (.*)/gm;
      let paterns = [...modelViewer.cameraOrbit.matchAll( cameraOrbitPattern )];
      setCameraHorizontal( paterns[0][1] );
      setCameraVertical( paterns[0][2] );
      setCameraZoom( paterns[0][3] );
      setSugarModelViewer( modelViewer );
    }
  }, [productMatches] );

  const handleExportObj = ( item ) => {
    const newState = exportObj.map( ( obj ) => {
      if ( obj.name === item.name )
        return {
          ...obj,
          isSelected: !obj.isSelected,
        };
      return obj;
    } );
    return setExportObj( newState );
  };
  const handleDisableProduct=()=>{
    setDisabled(!disabled);
    api.productSetDisabled(editorProductInfo.id, !disabled);

}

  const handleUsePoster = ( e ) => {
    setUsePoster( e );
  };

  const handleUseThumbnail = ( e ) => {
    setUseThumbnail( e );
  };

  const handleChangeHorizontal = ( e ) => {
    e = e == "" ? "0" : e;
    const cOrbit = e + "deg" + " " + cameraVertical + "deg" + " " + cameraZoom;
    sugarModelViewer.cameraOrbit = cOrbit;

    setCameraOrbit( cOrbit );
    setCameraHorizontal( e );
  };

  const handleChangeVertical = ( e ) => {
    e = e == "" ? "0" : e;
    const cOrbit =
      cameraHorizontal + "deg" + " " + e + "deg" + " " + cameraZoom;
    sugarModelViewer.cameraOrbit = cOrbit;

    setCameraOrbit( cOrbit );
    setCameraVertical( e );
  };

  const handleChangeZoom = ( e ) => {
    e = e == "" ? "auto" : e;
    const cOrbit =
      cameraHorizontal + "deg" + " " + cameraVertical + "deg" + " " + e;
    sugarModelViewer.cameraOrbit = cOrbit;

    setCameraOrbit( cOrbit );
    setCameraZoom( e );
  };



  const handleClickSaveMatch = ( e ) => {
    document.dispatchEvent(
      new CustomEvent( "open-editor-popup", {
        detail: "Match Ekelniyor, lütfen bekleyiniz...",
      } )
    );

    console.log(editorProductInfo.company.id, editorProductInfo.id, matchCode);
    let url =
      process.env.REACT_APP_BACKEND_API + `editor/add/matches`;
    axios
      .get( url, {
        params: {
          companyId: editorProductInfo.company.id,
          productId: editorProductInfo.id,
          matchCode: matchCode,
        },
        headers: {
          Authorization: authenticationToken,
        },
      } )
      .then( ( res ) => {
        setProductMatches( [...res.data] );

        document.dispatchEvent(
          new CustomEvent( "update-editor-popup", { detail: "Match Eklendi." } )
        );

        setTimeout( () => {
          document.dispatchEvent(
            new CustomEvent( "close-editor-popup", { detail: "" } )
          );
        }, 1000 );
      } );
  };

  const handleClickDeleteMatch = async ( match ) => {
    try {
      await clearCacheForMatch( match );
    } catch ( error ) {
      console.error( "Cache temizlenemedi:", error );
    }

    let url =
      process.env.REACT_APP_BACKEND_API +
      `editor/delete/matches/${editorProductInfo.company.id}/${editorProductInfo.id}/${match.customerId}`;
    axios
      .get( url, {
        headers: {
          Authorization: authenticationToken,
        },
      } )
      .then( ( res ) => {
        setProductMatches( [...res.data] );
      } );
  };

  const clearCacheForMatch = ( match ) => {
    return axios( {
      method: "post",
      url: process.env.REACT_APP_BACKEND_API + `editor/clearCache`,
      params: {
        companyId: match.companyId,
        productId: match.customerId,
        sugarProductId: editorProductInfo.id,
      },
      headers: {
        Authorization: authenticationToken,
      },
    } );
  };

  const clearCache = async ( match ) => {
    document.dispatchEvent(
      new CustomEvent( "open-editor-popup", {
        detail: "Cache Temizleniyor, lütfen bekleyiniz...",
      } )
    );

    try {
      await clearCacheForMatch( match );
      document.dispatchEvent(
        new CustomEvent( "update-editor-popup", {
          detail: "Cache Temizlendi.",
        } )
      );
      setTimeout( () => {
        document.dispatchEvent(
          new CustomEvent( "close-editor-popup", { detail: "" } )
        );
      }, 10 );
    } catch {
      document.dispatchEvent(
        new CustomEvent( "update-editor-popup", {
          detail: "Cache Temizlenirken Hata olustu.",
        } )
      );

      setTimeout( () => {
        document.dispatchEvent(
          new CustomEvent( "close-editor-popup", { detail: "" } )
        );
      }, 1000 );
    }
  };

  const clearAllCache = async () => {
    if ( !productMatches.length ) {
      return;
    }

    document.dispatchEvent(
      new CustomEvent( "open-editor-popup", {
        detail: "Tüm cache temizleniyor, lütfen bekleyiniz...",
      } )
    );

    try {
      await Promise.all( productMatches.map( ( match ) => clearCacheForMatch( match ) ) );
      document.dispatchEvent(
        new CustomEvent( "update-editor-popup", {
          detail: "Tüm cache temizlendi.",
        } )
      );
      setTimeout( () => {
        document.dispatchEvent(
          new CustomEvent( "close-editor-popup", { detail: "" } )
        );
      }, 10 );
    } catch {
      document.dispatchEvent(
        new CustomEvent( "update-editor-popup", {
          detail: "Cache temizlenirken hata olustu.",
        } )
      );

      setTimeout( () => {
        document.dispatchEvent(
          new CustomEvent( "close-editor-popup", { detail: "" } )
        );
      }, 1000 );
    }
  };

  if ( a )
    return (
      <div className="column">
        <div style={{display:"flex",width:"100%",gap:"10px"}}>

        <div className="panel-group" style={{ flexDirection: "column" }}>
          <div className="row">
            <div
              className="column"
              onClick={() => handleExportObj( exportObj[0] )}
            >
              <div className="row" style={{ justifyContent: "flex-start" }}>
                <Checkbox checked={exportObj[0].isSelected} />
                <label style={{ color: "white" }}>{exportObj[0].name}</label>
              </div>
            </div>
            <div
              className="column"
              onClick={() => handleExportObj( exportObj[1] )}
            >
              <div className="row" style={{ justifyContent: "flex-start" }}>
                <Checkbox checked={exportObj[1].isSelected} />
                <label style={{ color: "white" }}>{exportObj[1].name}</label>
              </div>
            </div>
          </div>

          <div className="row">
            <div
              className="column"
              onClick={() => handleUseThumbnail( !useThumbnail )}
            >
              <div className="row" style={{ justifyContent: "flex-start" }}>
                <Checkbox checked={useThumbnail} />
                <label style={{ color: "white" }}>Thumbnail</label>
              </div>
            </div>
            <div className="column" onClick={() => handleUsePoster( !usePoster )}>
              <div className="row" style={{ justifyContent: "flex-start" }}>
                <Checkbox checked={usePoster} />
                <label style={{ color: "white" }}>Poster</label>
              </div>
            </div>
          </div>

          <div className="row">
            <div
              className="column"
              onClick={() => handleExportObj( exportObj[3] )}
            >
              <div className="row" style={{ justifyContent: "flex-start" }}>
                <Checkbox checked={exportObj[3].isSelected} />
                <label style={{ color: "white" }}>{exportObj[3].name}</label>
              </div>
            </div>
             <div className="column" >
              <div className="row" style={{justifyContent:"flex-start"}}>
              <Checkbox checked={!disabled}
              onChange={(e)=>handleDisableProduct(e)}/>
              <label style={{color:"white"}}>Disable Product</label>
              </div>
            </div>
          </div>
        </div>
        <div className="panel-group" style={{ flexDirection: "column" }}>
          <div className="row">
            <div className="column">
              <label className="textArea" style={{ color: "white" }}>
                H
              </label>
              <input
                value={cameraHorizontal}
                onChange={( e ) => handleChangeHorizontal( e.currentTarget.value )}
                style={{ width: "40px" }}
              />
            </div>

            <div className="column">
              <label className="textArea" style={{ color: "white" }}>
                V
              </label>
              <input
                value={cameraVertical}
                onChange={( e ) => handleChangeVertical( e.currentTarget.value )}
                style={{ width: "40px" }}
              />
            </div>

            <div className="column">
              <label className="textArea" style={{ color: "white" }}>
                Z
              </label>
              <input
                value={cameraZoom}
                onChange={( e ) => handleChangeZoom( e.currentTarget.value )}
                style={{ width: "40px" }}
              />
            </div>
          </div>
       
        </div>

        <div
        className="panel-group" style={{flexDirection:"column",width:"35%"}}
        ><Dimension/>
        
        </div>
        </div>
        
        <div className="panel-group" style={{ flexDirection: "column" }}>
          <div className="row">
            <div className="column" style={{ alignItems: "flex-end", width: "100%" }}>
              <button
                className="saveButton"
                style={{ float: "right", backgroundColor: "green" }}
                disabled={!productMatches.length}
                onClick={() => {
                  clearAllCache();
                }}
              >
                Clear All
              </button>
            </div>
          </div>
          {productMatches.map( ( key, index ) => {
            return (
              <div className="row" key={"modelV" + index}>
                <div className="column" style={{ alignItems: "flex-start" }}>
                  {key.companyId}
                </div>
                <div className="column" style={{ alignItems: "flex-start" }}>
                  {key.customerId}
                </div>
                <div className="column" style={{ alignItems: "flex-end" }}>
                  {" "}
                  <button
                    className="saveButton"
                    style={{ float: "right", backgroundColor: "green" }}
                    onClick={( e ) => {
                      clearCache( key );
                    }}
                  >
                    Clear
                  </button>
                </div>
                <div className="column" style={{ alignItems: "flex-end" }}>
                  {" "}
                  <button
                    className="saveButton"
                    style={{
                      float: "right",
                      width: "60px",
                      backgroundColor: "red",
                    }}
                    onClick={( e ) => {
                      handleClickDeleteMatch( key );
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            );
          } )}

          <div className="row">
            <div className="column" style={{ alignItems: "flex-start" }}>
              <label style={{ width: "40px" }}>{editorProductInfo.id}</label>
            </div>
            <div className="column" style={{ alignItems: "flex-start" }}>
              <label style={{ width: "40px" }}>
                {editorProductInfo.company.id}
              </label>
            </div>
            <div className="column" style={{ alignItems: "flex-start" }}>
              <input
                value={matchCode}
                onChange={( e ) => setMatchCode( e.target.value )}
                style={{ width: "100%" }}
              />
            </div>
            <div className="column" style={{ alignItems: "flex-end" }}>
              <button
                className="saveButton"
                onClick={( e ) => {
                  handleClickSaveMatch();
                }}
                style={{ float: "right", width: "60px" }}
              >
                Add
              </button>
            </div>
          </div>
        </div>

        
      </div>
    );
}
export default ModelVCheckbox;
